import { trigger, state, animate, transition, style, group, query } from '@angular/animations';


export const tooltipAnimation = trigger('tooltipAnimation', [
  transition('classic => void',[
    group([
      query('content-selector2', animate('.45s ease-in', style({opacity: 0})),{optional: true} ),
      style({opacity:1}),
      animate('.15s ease-in', style({opacity:0}))
    ])
  ]),

  /**
   * SIDEBAR ANIMATIONS
  */

  // SIDEBAR MOVE LEFT
  transition(
    '* => sidebar-move-left', 
    [
      style({transform: 'translateX(-100%)'}),
     // query('.tooltip-body', style({opacity:0})),
      animate('250ms ease-out', style({ transform: 'translateX(0%)' })),
      //query('.tooltip-body', animate('.25s ease-out', style({opacity:1}))),
    ]
  ),
  transition(
    'sidebar-move-left => void',
    group([
      query('content-selector2', animate('.45s ease-in', style({opacity: 0})),{optional: true} ),
      style({ transform: 'translateX(0%)' }),
      animate('.15s ease-in', style({ transform: 'translateX(-100%)' }))
    ])
  ),

  // SIDEBAR MOVE RIGHT
  transition(
    '* => sidebar-move-right', 
    [
      style({transform: 'translateX(100%)'}),
      //query('.tooltip-body', style({opacity:0})),
      animate('250ms ease-out', style({ transform: 'translateX(0%)' })),
      //query('.tooltip-body', animate('.25s ease-out', style({opacity:1}))),
    ]
  ),
  transition(
    'sidebar-move-right => void',
    group([
      query('content-selector2', animate('.45s ease-in', style({opacity: 0})),{optional: true} ),
      style({ transform: 'translateX(0%)' }),
      animate('.15s ease-in', style({ transform: 'translateX(100%)' }))
    ])
  ),

  // SIDEBAR SCALE LEFT
  transition(
    '* => sidebar-scale-left', 
    [
      style({transform: 'rotateY(90deg)', transformOrigin: 'left'}),
      //query('.tooltip-body', style({opacity:0})),
      animate('250ms ease-out', style({ transform: 'rotateY(0)', transformOrigin: 'left' })),
      //query('.tooltip-body', animate('.25s ease-out', style({opacity:1}))),
    ]
  ),
  transition(
    'sidebar-scale-left => void',
    group([
      query('content-selector2', animate('.45s ease-in', style({opacity: 0})),{optional: true} ),
      style({ transform: 'rotateY(0)',  transformOrigin: 'left' }),
      animate('.15s ease-in', style({transform: 'rotateY(90deg)', transformOrigin: 'left'}))
    ])
  ),

   // SIDEBAR SCALE RIGHT
   transition(
    '* => sidebar-scale-right', 
    [
      style({transform: 'rotateY(-90deg)', transformOrigin: 'right'}),
      //query('.tooltip-body', style({opacity:0})),
      animate('250ms ease-out', style({ transform: 'rotateY(0)', transformOrigin: 'right' })),
      //query('.tooltip-body', animate('.25s ease-out', style({opacity:1}))),
    ]
  ),
  transition(
    'sidebar-scale-right => void',
    group([
      query('content-selector2', animate('.45s ease-in', style({opacity: 0})),{optional: true} ),
      style({ transform: 'rotateY(0)',  transformOrigin: 'right' }),
      animate('.15s ease-in', style({transform: 'rotateY(-90deg)', transformOrigin: 'right'}))
    ])
  ),

   // SIDEBAR SCALE RIGHT
   transition(
    '* => sidebar-fade', 
    [
      style({opacity:0}),
     // query('.tooltip-body', style({opacity:0})),
      animate('250ms ease-out', style({opacity:1})),
      //query('.tooltip-body', animate('.25s ease-out', style({opacity:1}))),
    ]
  ),
  transition(
    'sidebar-fade => void',
    group([
      query('content-selector2', animate('.45s ease-in', style({opacity: 0})),{optional: true} ),
      style({opacity:1}),
      animate('.15s ease-in', style({opacity:0}))
    ])
  ),


 /**
   * FULLSCREEN ANIMATIONS
  */
  // FULLSCREEN SCALE
  transition(
    '* => fullscreen-scale',
   [
      style({ transform: 'scale(.5)', opacity: 0}),
     // query('.tooltip-body', style({opacity:0})),
      animate('.25s ease-out', style({ transform: 'scale(1)', opacity: 1})),
      //query('.tooltip-body', animate('.25s ease-out', style({opacity:1}))),
    ]
  ),
  transition('fullscreen-scale => void', [
    group([
      query('content-selector2', animate('.45s ease-in', style({opacity: 0})),{optional: true} ),
      style({ opacity: 1, transform: 'scale(1)',}),
      animate('.15s ease-in', style({ opacity: 0,   transform: 'scale(0.5)', }))
    ])
  ]),

  // FULLSCREEN FADE
  transition(
    '* => fullscreen-fade',[
      style({opacity: 0}),
      //query('.tooltip-body', style({opacity:0})),
      animate('.25s ease-out',style({ opacity: 1 })),
      //query('.tooltip-body', animate('.25s ease-out', style({opacity:1}))),
    ]
  ),

  transition('fullscreen-fade => void', [
    group([
      query('content-selector2', animate('.45s ease-in', style({opacity: 0})),{optional: true} ),
      style({opacity: 1}),
      animate('.15s ease-in', style({ opacity: 0 }))
    ])
  ]),

  // FULLSCREEN MOVE
  transition(
    '* => fullscreen-move',[
      style({transform: 'translateY(-120%)'}),
      //query('.tooltip-body', style({opacity:0, transform: 'translateY(10%)'})),
      animate('.35s ease-out',style({ transform: 'translateY(0%)' })),
      //query('.tooltip-body', animate('.25s ease-out', style({opacity:1, transform: 'translateY(0%)'}))),
    ]
  ),

  transition('fullscreen-move => void', [
      group([
        query('content-selector2', animate('.45s ease-in', style({opacity: 0})),{optional: true} ),
        style({transform: 'translateY(0%)'}),
        animate('.45s ease-in', style({ transform: 'translateY(-120%)' }))
      ]),
    ])
   
]);
